import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import { secretKey } from "../.././data";
import SelectSearch from "react-select-search";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const AddLeadNote = (props) => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [clientId, setClientId] = useState(+props.leadData.id);

  const getData = () => {
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const handleContentChange = (e) => {
    setContent(e.target.value);
  };

  const addSellNote = async (e) => {
    if (validatePayment()) {
      setLoading(true);
      var body = {
        content: content.replaceAll("'", ""),
        leadId: props.leadData.id,
        addUser: props.user,
      };

      await fetch("https://apidevkppp.ftpeople.pl/insertSellNote", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction("Dodano notatkę dla leada", props.leadData.id);

      MySwal.fire({
        icon: "success",
        title: "Dodano",
        text: "kontakt z klientem",
      }).then(async (result) => {
        props.close();
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const validatePayment = (e) => {
    if (content.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="mainContainerAddClientContact">
      {loading ? (
        <LoadingPopup id="popUpLoading" />
      ) : (
        <>
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div id="addPaymentIC" className="inputContainer">
            <div className="inputBox">
              <div className="inputCol_1">
                <label>Treść notatki</label>
                <textarea
                  spellCheck="false"
                  className="textAreaNote"
                  type="text"
                  id="url"
                  name="url"
                  value={content}
                  onChange={handleContentChange}
                />
              </div>
            </div>

            <div className="saveBoxAP">
              <button className="paymentMenuButton" onClick={addSellNote}>
                zapisz
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AddLeadNote;
